"use strict";
import { getRequest, postRequest } from "@/services/RequestService";
import { patchRequest } from "./RequestService";

export const getEmergencyNumber = async () => {
  const base_route = `/admin/emergency-numbers`;
  const response = await getRequest(base_route);
  return response;
};

export const storeEmergencyNumber = async request => {
  const base_route = `/admin/emergency-numbers`;
  const response = await postRequest(base_route, request);
  return response;
};

export const updateEmergencyNumber = async (id, request) => {
  const base_route = `/admin/emergency-numbers/${id}`;
  const response = await patchRequest(base_route, request);
  return response;
};
